<template>
  <div class="contact" v-smoothscroll="{ duration : 500 }">
    <div class="contact__body">
      <h1 class="contact__body--title">
        {{ $t("contactTranslate.contactBody.title") }}
      </h1>
      <div class="contact__body--profiles">
        <div class="contact__body--profiles--profile contact__body--profiles--profile--1">
          <h3 class="contact__body--profiles--profile--name">{{ $t("contactTranslate.contactBody.profile1.name") }}</h3>
          <a href="" class="contact__body--profiles--profile--phone">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>phone</title><path d="M16.4,3.2H8.6A1.4,1.4,0,0,0,7.2,4.6V20.4a1.4,1.4,0,0,0,1.4,1.4h7.8a1.4,1.4,0,0,0,1.4-1.4V4.6A1.4,1.4,0,0,0,16.4,3.2ZM10.6,4h3.8c.1,0,.2.2.2.3s-.1.4-.2.4H10.6c-.1,0-.2-.2-.2-.4S10.5,4,10.6,4Zm1.9,16.5a.9.9,0,1,1,.9-.9A.9.9,0,0,1,12.5,20.5Zm4.3-3H8.2V5.5h8.6Z" fill="$color__secondary"/></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile1.phone") }}
            </span>
          </a>
          <a :href="'mailto:' + $t('contactTranslate.contactBody.profile1.email')" class="contact__body--profiles--profile--email">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><text transform="translate(4.4 16.8)" font-size="16" fill="$color__secondary" font-family="ArialMT, Arial">@</text></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile1.email") }}
            </span>
          </a>
        </div>
        <!-- <div class="contact__body--profiles--profile contact__body--profiles--profile--2">
          <h3 class="contact__body--profiles--profile--name">{{ $t("contactTranslate.contactBody.profile2.name") }}</h3>
          <a href="" class="contact__body--profiles--profile--phone">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>phone</title><path d="M16.4,3.2H8.6A1.4,1.4,0,0,0,7.2,4.6V20.4a1.4,1.4,0,0,0,1.4,1.4h7.8a1.4,1.4,0,0,0,1.4-1.4V4.6A1.4,1.4,0,0,0,16.4,3.2ZM10.6,4h3.8c.1,0,.2.2.2.3s-.1.4-.2.4H10.6c-.1,0-.2-.2-.2-.4S10.5,4,10.6,4Zm1.9,16.5a.9.9,0,1,1,.9-.9A.9.9,0,0,1,12.5,20.5Zm4.3-3H8.2V5.5h8.6Z" fill="$color__secondary"/></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile2.phone") }}
            </span>
          </a>
          <a href="" class="contact__body--profiles--profile--email">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><text transform="translate(4.4 16.8)" font-size="16" fill="$color__secondary" font-family="ArialMT, Arial">@</text></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile2.email") }}
            </span>
          </a>
        </div> -->
        <!-- <div class="contact__body--profiles--profile contact__body--profiles--profile--3">
          <h3 class="contact__body--profiles--profile--name">{{ $t("contactTranslate.contactBody.profile3.name") }}</h3>
          <a href="" class="contact__body--profiles--profile--phone">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>phone</title><path d="M16.4,3.2H8.6A1.4,1.4,0,0,0,7.2,4.6V20.4a1.4,1.4,0,0,0,1.4,1.4h7.8a1.4,1.4,0,0,0,1.4-1.4V4.6A1.4,1.4,0,0,0,16.4,3.2ZM10.6,4h3.8c.1,0,.2.2.2.3s-.1.4-.2.4H10.6c-.1,0-.2-.2-.2-.4S10.5,4,10.6,4Zm1.9,16.5a.9.9,0,1,1,.9-.9A.9.9,0,0,1,12.5,20.5Zm4.3-3H8.2V5.5h8.6Z" fill="$color__secondary"/></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile3.phone") }}
            </span>
          </a>
          <a href="" class="contact__body--profiles--profile--email">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><text transform="translate(4.4 16.8)" font-size="16" fill="$color__secondary" font-family="ArialMT, Arial">@</text></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile3.email") }}
            </span>
          </a>
        </div> -->
        <!-- <div class="contact__body--profiles--profile contact__body--profiles--profile--4">
          <h3 class="contact__body--profiles--profile--name">{{ $t("contactTranslate.contactBody.profile4.name") }}</h3>
          <a href="" class="contact__body--profiles--profile--phone">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><title>phone</title><path d="M16.4,3.2H8.6A1.4,1.4,0,0,0,7.2,4.6V20.4a1.4,1.4,0,0,0,1.4,1.4h7.8a1.4,1.4,0,0,0,1.4-1.4V4.6A1.4,1.4,0,0,0,16.4,3.2ZM10.6,4h3.8c.1,0,.2.2.2.3s-.1.4-.2.4H10.6c-.1,0-.2-.2-.2-.4S10.5,4,10.6,4Zm1.9,16.5a.9.9,0,1,1,.9-.9A.9.9,0,0,1,12.5,20.5Zm4.3-3H8.2V5.5h8.6Z" fill="$color__secondary"/></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile4.phone") }}
            </span>
          </a>
          <a href="" class="contact__body--profiles--profile--email">
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 25 25"><text transform="translate(4.4 16.8)" font-size="16" fill="$color__secondary" font-family="ArialMT, Arial">@</text></svg>
            <span>
              {{ $t("contactTranslate.contactBody.profile4.email") }}
            </span>
          </a>
        </div> -->
      </div>
    </div>
    <formContact></formContact>
  </div>
</template>

<script>

export default {
  name: 'contact',
  data () {
    return {
      locale: 'fr'
    }
  },
  watch: {
    locale (val) {
      this.$i18n.locale = val
    }
  }
}

</script>
